import { render, staticRenderFns } from "./CostInfo.vue?vue&type=template&id=3bb5beba&scoped=true"
import script from "./CostInfo.vue?vue&type=script&lang=js"
export * from "./CostInfo.vue?vue&type=script&lang=js"
import style0 from "./CostInfo.vue?vue&type=style&index=0&id=3bb5beba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb5beba",
  null
  
)

export default component.exports